import Colour from 'components/utils/Colour'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import { getThemeClassName } from 'lib/theme/themeUtils'
import TextButton from 'LuxKit/Button/TextButton'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import React from 'react'
import {
  LUX_PLUS_SIA_MASTERCARD_FLIGHTS_URL,
  LUX_PLUS_SIA_MASTERCARD_BECOME_MEMBER_URL,
  LUX_PLUS_SIA_MASTERCARD_PROMO_CODE,
} from '../constants/luxPlusSingaporeAirlinesMastercardTakeoverConstants'
import SolidPlaneIcon from 'LuxKit/Icons/solid/SolidPlaneIcon'

interface Props {
  withCta?: boolean
}

function LuxPlusSingaporeAirlinesMastercardOfferBanner({ withCta }: Props) {
  const isLuxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const memberSubscription = useAppSelector(state => state.auth.account.luxPlus.member.subscription.item)

  const hasActiveMembership = isLuxPlusEnabled && memberSubscription?.status === 'ACTIVE'

  const bannerCopy = `members earn up to $300 bonus LE Credit per person on Singapore Airlines flights when paying with an eligible Mastercard using code "${LUX_PLUS_SIA_MASTERCARD_PROMO_CODE}" at checkout.`

  // Banner only shows in AU region (controlled by useShowLuxPlusSiaMastercardBanner hook)
  // So we only have two states: AU member or non-member
  const ctaUrl = hasActiveMembership ? LUX_PLUS_SIA_MASTERCARD_FLIGHTS_URL : LUX_PLUS_SIA_MASTERCARD_BECOME_MEMBER_URL
  const ctaText = hasActiveMembership ? 'View details' : 'Become a member'

  return (
    <Group
      direction="horizontal"
      gap={12}
      verticalAlign="center"
      className={getThemeClassName({ mobile: 'inverse' })}
    >
      <SolidPlaneIcon size={48} />
      <BodyText variant="large">
        <b>LuxPlus<Colour value="highlight-lux-plus">+</Colour></b> {bannerCopy}
        {withCta && (
          <CSSBreakpoint as="span" max="mobile">
            {'  '}<TextLink
              to={ctaUrl}
              wrap="no-wrap"
            >
              {ctaText}
            </TextLink>
          </CSSBreakpoint>
        )}
      </BodyText>
      {withCta && (
        <CSSBreakpoint min="tablet" className={getThemeClassName({ mobile: 'inverse' })}>
          <TextButton
            kind="secondary"
            size="small"
            to={ctaUrl}
          >
            {ctaText}
          </TextButton>
        </CSSBreakpoint>
      )}
    </Group>
  )
}

export default LuxPlusSingaporeAirlinesMastercardOfferBanner
